import AccountTable from "../../components/selfcare/AccountTable/AccountTable";
import {useCustomer} from "../../layouts/SelfcareLayout";
import SelfcarePageContent from "../../components/selfcare/SelfcarePageContent";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";

export default function AccountPage() {
    setTitleAndMetaDescription("Profil - Mit Hiper", "Her kan du se og redigere dine kontaktoplysninger, kontakttilladelser og adgangskode.");

    const {customer} = useCustomer()

    return <SelfcarePageContent>
        <div className="selfcare-page-summary">
            <h1 className="heading heading--big">Profil</h1>
            <p>Du kan se og redigere dine kontaktoplysninger, kontakttilladelser og adgangskode her.</p>
        </div>

        <AccountTable customer={customer}/>
    </SelfcarePageContent>
}
